import { useDuplicateEstimate } from '@/hooks/useEstimate';
import Modal from '../ui/Modal';
import { useToast } from '@/hooks/useToast';
import { useTranslation } from '@/i18n';

interface DuplicateEstimateModalProps {
  closeModal: () => void;
  projectId: string;
  estimateId: string;
}

const DuplicateEstimateModal = ({
  closeModal,
  estimateId,
  projectId,
}: DuplicateEstimateModalProps) => {
  const { mutateAsync: duplicateEstimate } = useDuplicateEstimate(projectId);
  const { toastAsync } = useToast();
  const { t } = useTranslation();

  return (
    <Modal
      title={t('estimates.modals.duplicateEstimate.title')}
      actionTitle={t('estimates.modals.duplicateEstimate.actionTitle')}
      closeModal={closeModal}
      actionOnClick={() =>
        toastAsync(duplicateEstimate(estimateId), {
          success: t('estimates.modals.duplicateEstimate.success'),
        })
      }
      message={t('estimates.modals.duplicateEstimate.message')}
    />
  );
};

export default DuplicateEstimateModal;
